import { useNavigate } from "react-router-dom";
import { Column } from "../../../../../core/components/Column";
import { TextComponent } from "../../../../../core/components/TextComponent";
import { CustomInput } from "../../../../../core/components/CustomInput";
import { CustomButton } from "../../../../../core/components/CustomButton";
import { UsernameFormValues, usernameValidationSchema } from "../../interfaces/UsernameFormInterface";
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import { setUserInfo } from "../../store/OnboardingSlice";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "../../../../../core/components/Container";
import { RootState } from "../../../../../core/store/store";


export const OnBoardingUsername = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const username = useSelector((state: RootState) => state.onboarding.userInfo?.username) || "";
    const initialValues: UsernameFormValues = {
        username: username ?? '',
    };

    const handleSubmit = (values: UsernameFormValues, { setSubmitting }: FormikHelpers<UsernameFormValues>) => {
        dispatch(setUserInfo({ username: values.username }));
        navigate("/birth");
        setSubmitting(false);
    };

    return (
        <Column
            crossAxisAlignment="center"
            className=" my-5 md:my-10"
        >
            <Column className="gap-5 bg-white px-10  md:p-20 self-center text-center w-full md:w-[584px] lg:shadow-xl rounded-lg" crossAxisAlignment="center">
                <TextComponent variant="h2" className="font-bold">
                    Add your Username
                </TextComponent>
                <TextComponent variant='h6' className='text-[#6B6B6B]'>
                    Please add below your user name
                </TextComponent>
                <Column className="w-full gap-2">
                    <TextComponent variant="h6" className="text-left w-full">
                        User
                    </TextComponent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={usernameValidationSchema}
                        validateOnBlur
                        validateOnChange={false}
                        onSubmit={handleSubmit}
                    >
                        {({ handleChange, handleBlur }) => (
                            <Form className="flex flex-col w-full text-start gap-5">
                                <Container className="w-full">
                                    <Field
                                        as={CustomInput}
                                        id="username"
                                        name="username"
                                        type="text"
                                        hintText="Enter username"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        required
                                        />
                                    <ErrorMessage name="username" component="div" className="text-red-500 text-xs" />
                                </Container>
                                <CustomButton type="submit" children="Continue" />
                            </Form>
                        )}
                    </Formik>
                </Column>
            </Column>
        </Column>
    )
}
